module.exports = __webpack_public_path__ + "fonts/8436c5b3-8af1-40f9-acd7-48dfdcaeac50.fd00b446.woff2";